module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-pages-container"
  }, [(_vm.show_generic_display == 1 && _vm.all.length > 0) ? _c('button', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('show_generic_action'),
      expression: "'show_generic_action'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.withGeneric),
      expression: "withGeneric"
    }],
    staticClass: "btn btn-sm btn-generic",
    class: {
      filled: _vm.startGeneric
    },
    on: {
      "click": function($event) {
        return _vm.videoGenerique('debut')
      }
    }
  }, [_c('i', {
    staticClass: "icon-movie-clap"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-navigation",
    class: [{
      active: _vm.hasScrollSlides
    }]
  }, [_c('button', {
    staticClass: "  button-navigation--left btn btn-sm",
    attrs: {
      "id": "button-navigation-left",
      "disabled": !_vm.hasScrollSlides
    },
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, -1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "slides-panel row",
    attrs: {
      "id": "div-draggable"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "ps",
    staticClass: "scroll-area",
    attrs: {
      "id": "ps-slide-wrapper",
      "use-both-wheel-axes": true
    },
    on: {
      "ps-scroll-x": _vm.removeSmoothing,
      "ps-scroll-y": _vm.removeSmoothing
    }
  }, [_c('div', {
    staticClass: "row__inner",
    on: {
      "mousewheel": _vm.scrollHorizontally
    }
  }, [_c('draggable', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "id": "draggable-wrapper",
      "move": _vm.dragSlide
    },
    on: {
      "end": _vm.reorder,
      "start": _vm.getList
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-complete"
    }
  }, _vm._l((_vm.all), function(slide, index) {
    return _c('div', {
      key: 'list-complete-' + index,
      staticClass: "card-wrapper",
      class: {
        extended: slide.isExtended
      },
      attrs: {
        "data-uid": slide.uid
      }
    }, [_c('div', {
      staticClass: "transition-icon-wrapper"
    }, [_c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-center",
        modifiers: {
          "modal-center": true
        }
      }, {
        name: "show",
        rawName: "v-show",
        value: (_vm.show_transition && (index > 0 || _vm.startGeneric)),
        expression: "show_transition && (index > 0 || startGeneric)"
      }],
      staticClass: "transition-btn",
      class: {
        active: _vm.hasTransition(slide)
      },
      on: {
        "click": function($event) {
          return _vm.addTransition(slide)
        }
      }
    }, [_c('i', {
      staticClass: "icon-transition"
    })]), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.show_video_intro),
        expression: "show_video_intro"
      }],
      staticClass: "transition-btn",
      class: {
        active: _vm.hasStartGeneric(slide)
      },
      on: {
        "click": function($event) {
          return _vm.videoGenerique('intro', index)
        }
      }
    }, [_c('i', {
      staticClass: "icon-film-strip"
    })])], 1), _vm._v(" "), _c('panel-card', {
      attrs: {
        "index": index,
        "slide": slide,
        "isSelected": slide.uid === _vm.currentSegment.uid,
        "removable": _vm.all.length > 1,
        "showVideoIntro": {},
        "is-segment-card": true
      },
      on: {
        "selected": function($event) {
          return _vm.selectSegment(slide)
        },
        "duplicated": function($event) {
          return _vm.handleDuplicateSegment(slide, index)
        },
        "toggled": function($event) {
          return _vm.toggleSegmentCards(slide, index)
        },
        "insertSegment": function($event) {
          return _vm.handleInsertSegment(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "inner-slides-wrapper",
      class: {
        extended: slide.isExtended
      },
      style: (_vm.calculateWidth(slide))
    }, [_c('draggable', {
      key: _vm.segmentKey,
      staticClass: "inner-slides-container",
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "id": "nested-draggable-wrapper"
      },
      on: {
        "end": function($event) {
          return _vm.reorderSlides($event, index)
        }
      },
      model: {
        value: (_vm.lists[index]),
        callback: function($$v) {
          _vm.$set(_vm.lists, index, $$v)
        },
        expression: "lists[index]"
      }
    }, _vm._l((_vm.getScreens(slide)), function(slideScreen, i) {
      return _c('div', {
        key: i,
        staticClass: "slides-transitions-wrapper"
      }, [_c('panel-card', {
        attrs: {
          "index": i,
          "segment": slide,
          "slide": slideScreen,
          "isSelected": slideScreen.uid === _vm.currentSlide.uid
        },
        on: {
          "selected": function($event) {
            return _vm.selectSlide(slide, slideScreen)
          },
          "duplicated": function($event) {
            return _vm.handleDuplicateSlideInsideSegment(slide, slideScreen, index, i)
          }
        }
      })], 1)
    }), 0), _vm._v(" "), _c('b-button', {
      staticClass: "btn btn-sm add-segment-btn",
      attrs: {
        "pill": "",
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleAppendSlide(index)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('button.ecran')) + "\n                ")])], 1)], 1)
  }), 0)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "button-navigation",
    class: [{
      active: _vm.hasScrollSlides
    }]
  }, [_c('button', {
    staticClass: " button-navigation--right btn btn-sm",
    attrs: {
      "id": "button-navigation-right",
      "disabled": !_vm.hasScrollSlides
    },
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.show_generic_display == 1 && _vm.all.length > 0) ? _c('button', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('show_generic_action'),
      expression: "'show_generic_action'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.withGeneric),
      expression: "withGeneric"
    }],
    staticClass: "btn btn-sm btn-generic",
    class: {
      filled: _vm.finishGeneric
    },
    on: {
      "click": function($event) {
        return _vm.videoGenerique('fin')
      }
    }
  }, [_c('i', {
    staticClass: "icon-finish"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d728d6a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/PanelPages.vue
// module id = 816
// module chunks = 1 3